import { ComboBox, type ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import type { ProductUnitOptionDto } from "../../../../contracts";

type QuantitySelectorProps = {
    options: ProductUnitOptionDto[];
    isFetching: boolean;
    value: ProductUnitOptionDto | null;
    disabled: boolean;
    onChange: (option: string | null) => void;
};

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
    options,
    isFetching,
    value,
    disabled,
    onChange
}: QuantitySelectorProps) => {
    return (
        <div className="col-12">
            <label className="form-label small fw-semibold">
                Size
            </label>
            <ComboBox
                data={options}
                dataItemKey="pack_size_key"
                textField="display_value"
                value={value}
                placeholder={isFetching
                    ? "Loading quantities..."
                    : "Select quantities"}
                disabled={disabled || isFetching}
                clearButton={true}
                style={{ width: "100%" }}
                onChange={(event: ComboBoxChangeEvent): void => {
                    const data: ProductUnitOptionDto | null = event.value;
                    onChange(data?.pack_size_key ?? null);
                }}
            />
        </div>
    );
};

export default QuantitySelector;
